export default {
      id: "help-box-multiple-outline-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.b61b1948.svg#help-box-multiple-outline",
      toString: function () {
        return this.url;
      }
    }